<div class="container mt-2">

  <!-- 🔹 Top Action Bar (Back + Export + Print) -->
  <div class="d-flex justify-content-between align-items-center mb-3" *ngIf="ledgerDetails.length">
    <!-- Back Button (Left) -->
    <button type="button"
      class="btn btn-outline-primary d-flex align-items-center px-4 py-2 rounded-pill shadow-sm fw-semibold"
      (click)="goBack()">
      <i class="fa fa-arrow-left me-1"></i> Back
    </button>

    <!-- Export + Print Buttons (Right) -->
    <div>
      <button type="button" class="btn btn-success me-2" (click)="exportExcel()">
        <i class="fa fa-download me-1"></i> Export Excel
      </button>
      <button type="button" class="btn btn-primary" (click)="printLedger()">
        <i class="fa fa-print me-1"></i> Print
      </button>
    </div>
  </div>

  <!-- Ledger Report Header -->
  <div class="bg-white p-4 rounded mb-4 text-center" *ngIf="ledgerDetails.length">
    <h4 class="mb-3 fw-bold text-primary">{{ storeName }}</h4>
    <h5 class="form-label d-block fw-semibold">Ledger: {{ ledgerName }}</h5>
    <div class="gap-4">
      <div>
        <label class="form-label d-block">Basis: {{ reportBasis }}</label>
      </div>
      <div>
        <label class="form-label d-block">
          Report Date: {{ minDate | date:'dd/MM/yyyy' }} - {{ maxDate | date:'dd/MM/yyyy' }}
        </label>
      </div>
    </div>
  </div>

  <!-- 🔄 Global Loading Spinner -->
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.128)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white">{{ 'MENUITEMS.FINANCIALACCOUNTING.GROUP.Loading' | translate }}</p>
  </ngx-spinner>

  <!-- Ledger Table -->
  <table *ngIf="ledgerDetails.length" class="table table-hover align-middle" style="table-layout: fixed; width: 100%;">
    <thead class="table-primary">
      <tr>
        <th width="12%" style="word-wrap: break-word;">Voucher No</th>
        <th width="12%" style="word-wrap: break-word;">Voucher Date</th>
        <th width="34%" style="word-wrap: break-word;">Narration</th>
        <th width="14%" class="text-end" style="word-wrap: break-word;">Debit</th>
        <th width="14%" class="text-end" style="word-wrap: break-word;">Credit</th>
        <th width="14%" class="text-end" style="word-wrap: break-word;">Balance</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let entry of ledgerDetails">
        <td style="white-space: normal; word-wrap: break-word;">
       <a (click)="openVoucher(entry)" class="text-primary fw-semibold" style="cursor:pointer;">
  {{ entry.VoucherNo }}
</a>


        </td>
        <td style="white-space: normal; word-wrap: break-word;">{{ entry.VoucherDate | date:'dd/MM/yyyy' }}</td>
        <td style="white-space: normal; word-wrap: break-word;">{{ entry.Narration }}</td>
        <td class="text-end" style="white-space: normal; word-wrap: break-word;">
          {{ entry.Debit ? (entry.Debit | number:'1.2-2') : '0.00' }}
        </td>
        <td class="text-end" style="white-space: normal; word-wrap: break-word;">
          {{ entry.Credit ? (entry.Credit | number:'1.2-2') : '0.00' }}
        </td>
        <td class="text-end" style="white-space: normal; word-wrap: break-word;">
          {{ entry.Balance ? (entry.Balance | number:'1.2-2') : '0.00' }}
        </td>
      </tr>
    </tbody>

  </table>

</div>